export function toBoolean(variable: number | string | boolean): boolean {
  return !!variable && variable !== '0' && String(variable).toLowerCase() !== 'false';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function cloneObject(object: Record<any, any>) {
  return object ? Object.assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}

export function arrayToMap<T>(array: T[], keyName: string) {
  return array.reduce((acc, it) => {
    // @ts-expect-error TODO Fix
    acc.set(it[keyName], it);

    return acc;
  }, new Map<string, T>());
}
